import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { system as styledSystem } from '@styled-system/core';

const styledParser = styledSystem({
  padding: true,
});

const SrCardOld = ({ children, className, ..._styles }) => {
  return (
    <div className={classnames('SrCardOld', className)} style={styledParser(_styles)}>
      {children}
    </div>
  );
};

SrCardOld.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

SrCardOld.displayName = 'SrCardOld';

export default SrCardOld;
